import { useEffect, useState } from "react";
import { DirectoryUpload } from "./components/DirectoryUpload";
import { DocumentProcessing } from "./components/DocumentProcessing";
import { QRCodeDownload } from "./components/QRCodeDownload";
import { EmailRegistration } from "./components/EmailRegistration";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { loadLastQr } from "./lib/qrStorage";

export default function App() {
  const [currentStep, setCurrentStep] = useState<"upload" | "processing" | "download" | "register">("upload");
  const [qrCodePngUrl, setQrCodePngUrl] = useState<string | null>(null);
  const [qrCodeSvgUrl, setQrCodeSvgUrl] = useState<string | null>(null);
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null);
  const [isRestoredFromStorage, setIsRestoredFromStorage] = useState(false);

  const isPrivacyRoute =
    typeof window !== "undefined" && window.location.pathname === "/privacy-policy";

  const handleUpload = (args: {
    qrCodePngUrl?: string;
    qrCodeSvgUrl?: string;
    qrCodeUrl?: string;
  }) => {
    setIsRestoredFromStorage(false);
    setQrCodePngUrl(args.qrCodePngUrl ?? null);
    setQrCodeSvgUrl(args.qrCodeSvgUrl ?? null);
    setQrCodeUrl(args.qrCodeUrl ?? null);
    setCurrentStep("processing");
  };

  const handleProcessingComplete = () => {
    setCurrentStep("download");
  };

  const handleBackFromDownload = () => {
    setIsRestoredFromStorage(false);
    setCurrentStep("upload");
  };

  const handleStartOver = () => {
    setCurrentStep("upload");
  };

  const handleRegister = () => {
    setCurrentStep("register");
  };

  const handleBackFromRegister = () => {
    setCurrentStep("download");
  };

  useEffect(() => {
    // On first load, check if we have a previously stored QR to restore.
    const lastQr = loadLastQr();
    if (lastQr && lastQr.pngDataUrl && lastQr.targetUrl) {
      setQrCodePngUrl(lastQr.pngDataUrl);
      setQrCodeSvgUrl(null);
      setQrCodeUrl(lastQr.targetUrl);
      setIsRestoredFromStorage(true);
      setCurrentStep("download");
    }
  }, []);

  if (isPrivacyRoute) {
    return <PrivacyPolicy />;
  }

  if (currentStep === "upload") {
    return <DirectoryUpload onUpload={handleUpload} />;
  }

  if (currentStep === "processing") {
    return <DocumentProcessing onComplete={handleProcessingComplete} />;
  }

  if (currentStep === "download") {
    const isRestoredView =
      isRestoredFromStorage && qrCodePngUrl !== null && qrCodeUrl !== null;

    return (
      <QRCodeDownload
        onBack={handleBackFromDownload}
        onStartOver={handleRegister}
        qrCodePngUrl={qrCodePngUrl ?? undefined}
        qrCodeSvgUrl={qrCodeSvgUrl ?? undefined}
        qrCodeUrl={qrCodeUrl ?? undefined}
        mode={isRestoredView ? "restored" : "full"}
      />
    );
  }

  if (currentStep === "register") {
    return <EmailRegistration onBack={handleBackFromRegister} />;
  }

  return null;
}